import React from "react";

import PropTypes from "prop-types";
import { useParams } from "react-router-dom";

import WidgetUUIDContext from "./WidgetUUIDContext";

const WidgetUUIDContextProvider = ({ children }) => {
  const { widgetUUID } = useParams();

  return (
    <WidgetUUIDContext.Provider
      value={widgetUUID}
    >
      {children}
    </WidgetUUIDContext.Provider>
  );
};

WidgetUUIDContextProvider.propTypes = {
  children: PropTypes.node,
};

WidgetUUIDContextProvider.defaultProps = {
  children: null,
};

export default WidgetUUIDContextProvider;
